













































































































































import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'
import {Action, Getter, Mutation} from 'vuex-class';
import CalendarEvent, {EventRepeat} from '@/modules/calendar/model/CalendarEvent';
import LoadingScreen from '@/modules/core/LoadingScreen';
import CalendarEventDetail from '@/modules/calendar/components/CalendarEventDetail.vue';
import {Watch} from 'vue-property-decorator';
import CalendarEventTypeMasterDetail from '@/modules/calendar/components/CalendarEventTypeMasterDetail.vue';
import Loader from '@/components/Loader.vue';

/**
 * Calendario
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        Loader,
        CalendarEventTypeMasterDetail,
        CalendarEventDetail,
    },
})
export default class Calendar extends Vue {
    /**
     * Establece el evento actualmente mostrado al usuario
     */
    @Mutation('calendar/SET_CURRENT_CALENDAR_EVENT')
    public setCurrentCalendarEvent: (event: CalendarEvent) => void

    /**
     * Retorna una lista con todos los eventos que coincidan con la fecha argumentada, se puede
     * utilizar una cadena de texto con el formato YYYY-MM-DD
     */
    @Getter('calendar/matchedEvents')
    public matchedEvents: (date: Date | string) => CalendarEvent[]

    /**
     * Crea un nuevo evento limpio y lo inserta en el estado de la aplicación, además
     * establece el estado del calendario en modo "creación" indicando que el
     * usuario esta creando un nuevo evento
     */
    @Action('calendar/createNewEvent')
    public createNewEvent: () => void

    public date = moment()
    public loading = true
    public calendarEventTypeDialog = false

    /**
     *
     * Mueve la fecha actual del calendario a la fecha mas cercada que coincida con
     * los parámetros del evento
     *
     */
    @Watch('$store.state.calendar.currentCalendarEvent')
    public onCalendarEventChange (event: CalendarEvent) {
        switch (event.repeat) {
            case EventRepeat.Annual:
                this.date = this.date.clone().month(event.month - 1).date(event.monthDay)
                break
        }
    }

    /**
     * Fecha actual mostrada en el calendario, formateada para el componente de
     * Vuetify
     */
    public get calendarDate () {
        return this.date.format('YYYY-MM-DD')
    }

    public set calendarDate (value: string) {
        this.date = moment(value)
    }


    public prevYear () {
        this.date = this.date.clone().subtract(1, 'year')
    }

    public nextYear () {
        this.date = this.date.clone().add(1, 'year')
    }

    /**
     * Modifica la fecha actual del calendario y la define en el día actual
     * del sistema
     */
    public navigateToToday () {
        this.date = moment()
    }

    /**
     * Comprueba si la fecha actual del calendario coincide con el día actual
     */
    public get isToday () {
        return this.date.format('DD-MM-YYYY') === moment().format('DD-MM-YYYY')
    }

    public get todayEvents () {
        return this.matchedEvents(new Date())
    }

    public get todayHasEvents () {
        return !!this.todayEvents.length
    }

    /**
     * Al crear el componente carga la lista de eventos de calendario
     */
    public async created () {
        await this.$store.dispatch('calendar/loadCalendarEvents')
        this.loading = false
    }
}
